import React, { useEffect, useState } from "react";
import { CheckCircle } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";

const StepConfirmation = () => {
  const [countdown, setCountdown] = useState(30);
  const location = useLocation();
  const navigate = useNavigate();

  // URL du site Orpi
  const orpiUrl =
    "https://www.orpi.com/?utm_source=google&utm_medium=cpc&utm_campaign=FilR_SEARCH-Marque-Pure-+-G%C3%A9n%C3%A9rique_ORPI&utm_term=Marque-Pure&gad_source=1&gclid=Cj0KCQiAlbW-BhCMARIsADnwasr9rvzEK9cqqQ1GAL4eED5ujko5jHsm4k1nHq33AAZdF1albQ-EgJYaAtbmEALw_wcB";

  // Fonction pour rediriger vers le site Orpi
  const redirectToOrpi = () => {
    window.location.href = orpiUrl;
  };

  // Vérifier que l'utilisateur arrive bien de la page de finalisation
  useEffect(() => {
    // Si l'utilisateur accède directement à cette page sans passer par le flux normal
    if (!location.state || !location.state.dataSubmitted) {
      console.warn(
        "Accès direct à la page de confirmation sans soumission préalable."
      );
      // On peut soit rediriger vers la page d'accueil, soit laisser continuer
      // navigate('/', { replace: true });
      // Nous choisissons de laisser continuer mais sans redirection automatique
      return;
    }

    // Timer de 30 secondes pour la redirection automatique
    const timer = setInterval(() => {
      setCountdown((prevCount) => {
        if (prevCount <= 1) {
          clearInterval(timer);
          redirectToOrpi();
          return 0;
        }
        return prevCount - 1;
      });
    }, 1000);

    // Nettoyage du timer
    return () => {
      clearInterval(timer);
    };
  }, [location]);

  return (
    <div className="p-6 max-w-3xl mx-auto">
      <div className="text-center">
        <div className="flex justify-center mb-6">
          <CheckCircle className="text-orpi-primary h-24 w-24" />
        </div>

        <h1 className="text-3xl font-bold text-orpi-secondary mb-4">
          Votre demande a été envoyée avec succès !
        </h1>

        <p className="text-lg text-gray-600 mb-8">
          Nous avons bien reçu votre demande de logement ainsi que tous les
          documents nécessaires. Notre équipe va étudier votre dossier dans les
          meilleurs délais.
        </p>

        <div className="mt-6 bg-orpi-light p-4 rounded-lg">
          <div className="mt-6 border-t pt-4 border-orpi-primary">
            <h3 className="font-semibold text-lg text-orpi-secondary mb-2">
              Important :
            </h3>
            <p className="mb-3">
              Si plusieurs personnes sont concernées par votre dossier
              (conjoint(e), colocataire(s), garant(s)), veuillez transmettre ce
              formulaire à chacune d'entre elles.
            </p>
            <p className="mb-3">
              Une fois que toutes les personnes rattachées à votre dossier
              auront rempli leur formulaire, merci de nous adresser un mail à{" "}
              <a
                href="mailto:contact@orpi.live"
                className="text-orpi-primary hover:underline"
              >
                contact@orpi.live
              </a>{" "}
              en indiquant clairement le nom de chaque participant.
            </p>
          </div>
        </div>

        {location.state && location.state.dataSubmitted ? (
          <p className="text-sm text-gray-500 mb-8">
            Vous serez automatiquement redirigé vers notre site principal dans{" "}
            <span className="font-bold">{countdown}</span> secondes.
          </p>
        ) : (
          <p className="text-sm text-gray-500 mb-8">
            Vous pouvez maintenant retourner à notre site principal.
          </p>
        )}

        <button
          onClick={redirectToOrpi}
          className="bg-orpi-primary hover:bg-orpi-dark text-white font-semibold py-3 px-8 rounded-full transition-colors"
        >
          Retour à l'accueil
        </button>
      </div>
    </div>
  );
};

export default StepConfirmation;
